import React from 'react';
import TextInfo from '@bit/gerenciatd.unifiedcomponents.text-info';
import { generateBgAdvantage, giveRandomNumber } from './securityBenefitsUtils';
import './Banner.scss';

const Banner = ({ components }) => {
  const idBanner = `Banner${giveRandomNumber(0, 1000)}`;
  if (components.backgroundImg) {
    generateBgAdvantage(idBanner, components.backgroundImg);
  }


  return (
    <div id={idBanner} className={`Banner ${components.backgroundImg ? '' : 'Banner_bgColor'}`}>
      <div className={`Banner__container ${components.backgroundColor ? `Banner__container_bgColor--${components.backgroundColor}` : 'Banner__container_bgColor--blue'}`}>
        <div className="Banner__container__info">
          {components['TextInfo-1'] && (
          <TextInfo {...components['TextInfo-1']} className="Banner__container__info__title" />
          )}
          {components['TextInfo-2'] && (
            <TextInfo {...components['TextInfo-2']} className="Banner__container__info__subtitle" />
          )}
        </div>
      </div>
    </div>
  );
}

export default Banner;
